module.exports = __webpack_public_path__ + "assets/img/img-hotel-10.15d1a7b0.jpg";